/**
 * exta 归一化：详情 API 可能返回 string 或 object，表单内存态统一为 object。
 */

export function parseExtaObject(exta) {
  if (exta == null || exta === '') {
    return {}
  }
  if (typeof exta === 'object') {
    return { ...exta }
  }
  if (typeof exta === 'string') {
    try {
      const parsed = JSON.parse(exta)
      return parsed && typeof parsed === 'object' ? parsed : {}
    } catch (e) {
      return {}
    }
  }
  return {}
}
